<template>
  <div class="card p-3 shadow">
    <div v-if="results.length === 0 && loading === false">
      Пока нет результатов анализов
    </div>

    <Calendar :client="client" :results="results" :healthElements="healthElements" />
  </div>
</template>

<script>
  import Calendar from './test/Calendar';

  export default {
    name: 'ClientTest',

    components: { Calendar },

    props: ['client'],

    data() {
      return {
        loading: false,
      };
    },

    created() {
      this.loadUserData();
    },

    computed: {
      results() {
        return this.$store.getters.getTestClientResults(this.client.id);
      },

      healthElements() {
        return this.$store.state.clinic.healthElements;
      },
    },

    methods: {
      async loadUserData() {
        try {
          this.loading = true;


          await Promise.all([
            this.$store.dispatch('LOAD_HEALTH_ELEMENTS'),
            this.$store.dispatch('TEST_LOAD_RESULTS', this.client.id),
          ]);
        } catch (e) {
          this.error = e.message;
        }

        this.loading = false;
      },
    },
  };
</script>
